<template>
  <div class="ElecBoard">
    <b-row class="mx-0">
      <b-col :cols="window_innerWidth > 1200 ? 11 : 12">
        <b-row class="mx-0">
          <b-col cols="12" class="px-0 text-right my-2" style="font-size: 1rem">
            <span class="my-0" id="elecboard-update-time">更新時間:</span>
            <span class="my-0" for="elecboard-update-time">
              {{ nowtime }}
            </span>
          </b-col>

          <b-col :cols="window_innerWidth > 992 ? 1 : 0" class="px-0"></b-col>
          <b-col :cols="window_innerWidth > 992 ? 11 : 12" class="px-0">
            <b-row class="mx-0">
              <b-col
                cols="12"
                class="text-left"
                :class="{ 'px-0': window_innerWidth > 992 }"
                style="
                  color: #4b8c80;
                  font-size: 1.75rem;
                  font-family: dfyuanstd-w8, dfyuanstd-w7;
                "
              >
                <div v-if="process == '出貨'">
                  {{
                    tabIndex == 0
                      ? "出貨稼動率"
                      : tabIndex == 1
                      ? "即時資訊"
                      : tabIndex == 2
                      ? "齊貨狀態"
                      : ""
                  }}-{{ process }}
                </div>
                <div v-else-if="process == '包裝'">
                  {{
                    tabIndex == 0
                      ? "包裝稼動率"
                      : tabIndex == 1
                      ? "即時資訊"
                      : ""
                  }}-{{ process }}
                </div>
                <div v-else>
                  {{
                    tabIndex == 0
                      ? "即時資訊"
                      : tabIndex == 1
                      ? "開機稼動率"
                      : ""
                  }}-{{ process }}
                </div>
              </b-col>
              <b-col
                :cols="window_innerWidth > 672 ? 11 : 10"
                :class="{ 'px-0': window_innerWidth > 992 }"
              >
                <b-row class="mx-0">
                  <b-col
                    cols="1"
                    class="px-0 elecboard-device-col"
                    style="background-color: #4b8c80"
                    ref="group_title"
                  >
                    <div
                      class="my-3"
                      style="
                        color: #ffffff;
                        font-size: 1.5rem;
                        font-family: dfyuanstd-w8, dfyuanstd-w7;
                      "
                    >
                      {{ group_name }}
                    </div>
                    <template v-if="process == '熱處理'">
                      <p
                        style="
                          color: #ffffff;
                          font-size: 1.25rem;
                          font-family: dfyuanstd-w7, dfyuanstd-w5;
                        "
                        class="elecboard-group-img mt-4"
                      >
                        早班人員
                      </p>
                      <div
                        v-for="(item, key) in user_array"
                        :key="key"
                        class="mb-3 elecboard-group-img"
                      >
                        <template v-if="item.class == 'morning'">
                          <img
                            :src="item.image"
                            class="mx-auto mb-1"
                            alt="Center image"
                            height="81px"
                          />
                          <p
                            style="
                              color: #ffffff;
                              font-size: 1.125rem;
                              font-family: dfyuanstd-w7, dfyuanstd-w5;
                            "
                          >
                            {{ item.position + ":" + item.name }}
                          </p>
                        </template>
                      </div>
                      <p
                        style="
                          color: #ffffff;
                          font-size: 1.25rem;
                          font-family: dfyuanstd-w7, dfyuanstd-w5;
                        "
                        class="elecboard-group-img mt-4"
                      >
                        晚班人員
                      </p>
                      <div
                        v-for="(item, key) in user_array"
                        :key="key"
                        class="mb-3 elecboard-group-img"
                      >
                        <template v-if="item.class == 'evening'">
                          <img
                            :src="item.image"
                            class="mx-auto mb-1"
                            alt="Center image"
                            height="81px"
                          />
                          <p
                            style="
                              color: #ffffff;
                              font-size: 1.125rem;
                              font-family: dfyuanstd-w7, dfyuanstd-w5;
                            "
                          >
                            {{ item.position + ":" + item.name }}
                          </p>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        v-for="(item, key) in user_array"
                        :key="key"
                        class="mb-3 elecboard-group-img"
                      >
                        <img
                          :src="item.image"
                          class="mx-auto mb-1"
                          alt="Center image"
                          height="81px"
                        />
                        <p
                          style="
                            color: #ffffff;
                            font-size: 1.125rem;
                            font-family: dfyuanstd-w7, dfyuanstd-w5;
                          "
                        >
                          {{ item.position + ":" + item.name }}
                        </p>
                      </div>
                    </template>
                  </b-col>
                  <!-- 打頭 -->
                  <b-col
                    v-if="process == '打頭'"
                    cols="11"
                    class="px-0 elecboard-device-col"
                  >
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab title="即時資訊" lazy>
                        <b-row class="mx-0" ref="elecboard_detail_now">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="6"
                            lg="6"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="result_Data[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : result_Data[item].machine_status ==
                                            '短寸'
                                          ? '#99f98c'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : result_Data[item].machine_status ==
                                            '短寸'
                                          ? '#99f98c'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      result_Data[item].machine_status == "運作"
                                        ? "運作"
                                        : result_Data[item].machine_status ==
                                          "待機"
                                        ? "待機"
                                        : result_Data[item].machine_status ==
                                          "異常"
                                        ? "異常"
                                        : result_Data[item].machine_status ==
                                          "維修"
                                        ? "維修"
                                        : result_Data[item].machine_status ==
                                          "調車"
                                        ? "調車"
                                        : result_Data[item].machine_status ==
                                          "短寸"
                                        ? "短寸"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>速度(支/分):</span>
                                      <span>{{
                                        result_Data[item].device_capacity_min
                                      }}</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>工單餘量:</span>
                                      <span>{{
                                        result_Data[item]
                                          .day_remain_work_order_count
                                      }}</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>預計完成時數:</span>
                                      <span>{{
                                        result_Data[item].prediction_time
                                      }}</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>派工單號:</span>
                                      <span>
                                        <template
                                          v-if="
                                            result_Data[item].work_code != ''
                                          "
                                        >
                                          <!-- {{
                                            result_Data[item].work_code +
                                            "(" +
                                            result_Data[item].work_org_code +
                                            ")"
                                          }} -->
                                          {{ result_Data[item].work_org_code }}
                                        </template>
                                      </span>
                                    </div>
                                    <div>
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(item),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                item
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                      <!-- set_machineCameraData([
                                      {
                                        camera_name: 'IPCAM1',
                                        url:
                                          'http://59.125.151.183:88/GetData.cgi?CH=1&WebUser=admin&WebPass=',
                                      },
                                    ]), -->
                                      <!-- (nowPage = 'machstatus'), -->
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  目前進度:
                                  <div
                                    class="
                                      progress
                                      position-relative
                                      elecboard-progress-bar-height
                                    "
                                    style="
                                      width: calc(100% - 85px);
                                      margin-left: auto;
                                    "
                                  >
                                    <div
                                      v-if="result_Data[item].work_code == ''"
                                      class="progress-bar"
                                      style="
                                        width: 0%;
                                        background-color: #000000;
                                      "
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '運作'
                                      "
                                      class="progress-bar"
                                      style="background-color: #00b152"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '待機'
                                      "
                                      class="progress-bar"
                                      style="background-color: #ffc100"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '異常'
                                      "
                                      class="progress-bar"
                                      style="background-color: #c10000"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '維修'
                                      "
                                      class="progress-bar"
                                      style="background-color: #cccdfe"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '調車'
                                      "
                                      class="progress-bar"
                                      style="background-color: #09b0ff"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '短寸'
                                      "
                                      class="progress-bar"
                                      style="background-color: #99f98c"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <span
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                    <span
                                      v-if="result_Data[item].work_code == ''"
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                    <span
                                      v-else-if="
                                        result_Data[item].work_code != ''
                                      "
                                      class="elecboard-progress-bar-text mb-0"
                                      >{{
                                        result_Data[
                                          item
                                        ].device_now_count.toLocaleString(
                                          "en-US"
                                        ) +
                                        "/" +
                                        result_Data[
                                          item
                                        ].work_qty.toLocaleString("en-US") +
                                        "(" +
                                        result_Data[item].work_percent +
                                        "%)"
                                      }}</span
                                    >
                                  </div>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    未導入
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>速度(支/分):</span>
                                      <span>-</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>工單餘量:</span>
                                      <span>-</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>預計完成時數:</span>
                                      <span>-</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>派工單號:</span>
                                      <span></span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  目前進度:
                                  <div
                                    class="
                                      progress
                                      position-relative
                                      elecboard-progress-bar-height
                                    "
                                    style="
                                      width: calc(100% - 85px);
                                      margin-left: auto;
                                    "
                                  >
                                    <div
                                      class="progress-bar"
                                      style="
                                        width: 0%;
                                        background-color: #000000;
                                      "
                                    ></div>
                                    <span
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                  </div>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab title="開機稼動率" lazy class="">
                        <b-row class="mx-0" ref="elecboard_detail_activation">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="6"
                            lg="6"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="result_Data[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : result_Data[item].machine_status ==
                                            '短寸'
                                          ? '#99f98c'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : result_Data[item].machine_status ==
                                            '短寸'
                                          ? '#99f98c'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      result_Data[item].machine_status == "運作"
                                        ? "運作"
                                        : result_Data[item].machine_status ==
                                          "待機"
                                        ? "待機"
                                        : result_Data[item].machine_status ==
                                          "異常"
                                        ? "異常"
                                        : result_Data[item].machine_status ==
                                          "維修"
                                        ? "維修"
                                        : result_Data[item].machine_status ==
                                          "調車"
                                        ? "調車"
                                        : result_Data[item].machine_status ==
                                          "短寸"
                                        ? "短寸"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>
                                        {{
                                          result_Data[item].device_queue_time
                                        }}
                                      </span>
                                    </div>
                                    <div>
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(item),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                item
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                    </div>
                                  </b-col>
                                </b-row>

                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        result_Data[item].stack_bar_information
                                      "
                                      :stacksSize="'midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    未導入
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                  <!-- 輾牙 -->
                  <b-col
                    v-else-if="process == '輾牙'"
                    cols="11"
                    class="px-0 elecboard-device-col"
                  >
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab title="即時資訊" lazy>
                        <b-row class="mx-0" ref="elecboard_detail_now">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="6"
                            lg="6"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="result_Data[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      result_Data[item].machine_status == "運作"
                                        ? "運作"
                                        : result_Data[item].machine_status ==
                                          "待機"
                                        ? "待機"
                                        : result_Data[item].machine_status ==
                                          "異常"
                                        ? "異常"
                                        : result_Data[item].machine_status ==
                                          "維修"
                                        ? "維修"
                                        : result_Data[item].machine_status ==
                                          "調車"
                                        ? "調車"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>速度(支/分):</span>
                                      <span>{{
                                        result_Data[
                                          item
                                        ].device_capacity_min.toLocaleString(
                                          "en-US"
                                        )
                                      }}</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>工單總支數:</span>
                                      <span>{{
                                        result_Data[
                                          item
                                        ].work_qty.toLocaleString("en-US")
                                      }}</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>剩餘支數:</span>
                                      <span>{{
                                        result_Data[
                                          item
                                        ].work_remain_count.toLocaleString(
                                          "en-US"
                                        )
                                      }}</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>派工單號:</span>
                                      <span>
                                        <template
                                          v-if="
                                            result_Data[item].work_code != ''
                                          "
                                        >
                                          <!-- {{
                                            result_Data[item].work_code +
                                            "(" +
                                            result_Data[item].work_org_code +
                                            ")"
                                          }} -->
                                          {{ result_Data[item].work_org_code }}
                                        </template>
                                      </span>
                                    </div>
                                    <div>
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(item),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                item
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                      <!-- set_machineCameraData([
                                      {
                                        camera_name: 'IPCAM1',
                                        url:
                                          'http://59.125.151.183:88/GetData.cgi?CH=1&WebUser=admin&WebPass=',
                                      },
                                    ]), -->
                                      <!-- (nowPage = 'machstatus'), -->
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  目前進度:
                                  <div
                                    class="
                                      progress
                                      position-relative
                                      elecboard-progress-bar-height
                                    "
                                    style="
                                      width: calc(100% - 85px);
                                      margin-left: auto;
                                    "
                                  >
                                    <div
                                      v-if="result_Data[item].work_code == ''"
                                      class="progress-bar"
                                      style="
                                        width: 0%;
                                        background-color: #000000;
                                      "
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '運作'
                                      "
                                      class="progress-bar"
                                      style="background-color: #00b152"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '待機'
                                      "
                                      class="progress-bar"
                                      style="background-color: #ffc100"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '異常'
                                      "
                                      class="progress-bar"
                                      style="background-color: #c10000"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '維修'
                                      "
                                      class="progress-bar"
                                      style="background-color: #cccdfe"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <div
                                      v-else-if="
                                        result_Data[item].work_code != '' &&
                                        result_Data[item].work_percent != '' &&
                                        result_Data[item].machine_status ==
                                          '調車'
                                      "
                                      class="progress-bar"
                                      style="background-color: #09b0ff"
                                      :style="{
                                        width:
                                          result_Data[item].work_percent + '%',
                                      }"
                                    ></div>
                                    <span
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                    <span
                                      v-if="result_Data[item].work_code == ''"
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                    <span
                                      v-else-if="
                                        result_Data[item].work_code != ''
                                      "
                                      class="elecboard-progress-bar-text mb-0"
                                      >{{
                                        result_Data[
                                          item
                                        ].device_now_count.toLocaleString(
                                          "en-US"
                                        ) +
                                        "/" +
                                        result_Data[
                                          item
                                        ].work_qty.toLocaleString("en-US") +
                                        "(" +
                                        result_Data[item].work_percent +
                                        "%)"
                                      }}</span
                                    >
                                  </div>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    未導入
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>速度(支/分):</span>
                                      <span>-</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>工單總支數:</span>
                                      <span>-</span>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>剩餘支數:</span>
                                      <span>-</span>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>派工單號:</span>
                                      <span></span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  目前進度:
                                  <div
                                    class="
                                      progress
                                      position-relative
                                      elecboard-progress-bar-height
                                    "
                                    style="
                                      width: calc(100% - 85px);
                                      margin-left: auto;
                                    "
                                  >
                                    <div
                                      class="progress-bar"
                                      style="
                                        width: 0%;
                                        background-color: #000000;
                                      "
                                    ></div>
                                    <span
                                      class="elecboard-progress-bar-text mb-0"
                                    ></span>
                                  </div>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab title="開機稼動率" lazy class="">
                        <b-row class="mx-0" ref="elecboard_detail_activation">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="6"
                            lg="6"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="result_Data[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : result_Data[item].machine_status ==
                                            '調車'
                                          ? '#09b0ff'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      result_Data[item].machine_status == "運作"
                                        ? "運作"
                                        : result_Data[item].machine_status ==
                                          "待機"
                                        ? "待機"
                                        : result_Data[item].machine_status ==
                                          "異常"
                                        ? "異常"
                                        : result_Data[item].machine_status ==
                                          "維修"
                                        ? "維修"
                                        : result_Data[item].machine_status ==
                                          "調車"
                                        ? "調車"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>
                                        {{
                                          result_Data[item].device_queue_time
                                        }}
                                      </span>
                                    </div>
                                    <div>
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(item),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                item
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                    </div>
                                  </b-col>
                                </b-row>

                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        result_Data[item].stack_bar_information
                                      "
                                      :stacksSize="'midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    未導入
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                  <!-- 熱處理 -->
                  <b-col
                    v-else-if="process == '熱處理'"
                    cols="11"
                    class="px-0 elecboard-device-col"
                    style="overflow-x: auto"
                  >
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab title="即時訊息" lazy>
                        <b-row
                          class="row mx-0"
                          style="min-width: 1180px"
                          ref="heatTreatmentImage_detail"
                        >
                          <b-col
                            cols="12 px-0"
                            style="background-color: #646569; color: #ffffff"
                          >
                            <table style="width: 100%">
                              <tr>
                                <td
                                  style="
                                    min-width: 58px;
                                    width: 58px;
                                    text-align: right;
                                    padding-right: 10px;
                                  "
                                >
                                  入料區
                                </td>
                                <td style="min-width: 65px; width: 65px">
                                  前清洗區
                                </td>
                                <td style="min-width: 270px; width: 270px">
                                  淬火區
                                </td>
                                <td style="min-width: 65px; width: 65px">
                                  後清洗區
                                </td>
                                <td style="min-width: 230px; width: 230px">
                                  回火區
                                </td>
                                <td style="min-width: 40px; width: 40px">
                                  收料區
                                </td>
                              </tr>
                            </table>
                          </b-col>
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            class="px-0 elecboard-device-col"
                          >
                            <!-- <div class="text-left px-2">{{ item }}</div> -->
                            <template v-if="result_Data[item] != undefined">
                              <div
                                :style="{
                                  height:
                                    (heatTreatmentImage_height < 210 ||
                                    heatTreatmentImage_height == undefined
                                      ? 210
                                      : heatTreatmentImage_height) + 'px',
                                }"
                              >
                                <div
                                  :style="{
                                    left: '0px',
                                    width: '100%',
                                    height:
                                      (heatTreatmentImage_height < 175 ||
                                      heatTreatmentImage_height == undefined
                                        ? 175
                                        : heatTreatmentImage_height - 50) +
                                      'px',
                                    'background-color':
                                      result_Data[item].machine_status == '運作'
                                        ? 'rgb(0, 177, 82, .3)'
                                        : 'rgba(100, 101, 105, 0.3)',
                                  }"
                                  style="position: absolute"
                                ></div>
                                <div
                                  style="
                                    width: 100%;
                                    position: absolute;
                                    left: 0px;
                                  "
                                >
                                  <img
                                    :src="device_image[item]"
                                    alt=""
                                    style="
                                      width: 100%;
                                      height: auto;
                                      object-fit: contain;
                                    "
                                  />

                                  <!-- 熱處理工單 -->
                                  <div
                                    style="
                                      height: 100%;
                                      width: 97%;
                                      position: absolute;
                                      left: 2%;
                                      top: 0;
                                    "
                                  >
                                    <div
                                      v-for="(
                                        workItem, index
                                      ) in ht_work_display[item].work_schedule"
                                      :key="index"
                                      :id="workItem.work_code"
                                      :style="{
                                        color: '#fff',
                                        height: '2.5rem',
                                        width:
                                          workItem.first - workItem.last + '%',
                                        minWidth: '1%',
                                        position: 'absolute',
                                        left: workItem.last + '%',
                                        top: '15%',
                                        backgroundColor: '#00b152',
                                        overflow: 'hidden',
                                        cursor: 'default',
                                        transition: ht_work_display[item]
                                          .transition
                                          ? 'all 0.5s'
                                          : 'none',
                                      }"
                                    >
                                      {{
                                        workItem.org_code == ""
                                          ? workItem.work_code
                                          : workItem.org_code
                                      }}
                                      <b-popover
                                        :target="workItem.work_code"
                                        triggers="hover"
                                        placement="top"
                                        custom-class="elecboard-popover"
                                      >
                                        {{
                                          workItem.org_code == ""
                                            ? workItem.work_code
                                            : workItem.org_code
                                        }}
                                      </b-popover>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="mx-auto my-2"
                                  style="position: absolute; left: 12px"
                                  :style="{
                                    top:
                                      (heatTreatmentImage_height < 111 ||
                                      heatTreatmentImage_height == undefined
                                        ? 111
                                        : (heatTreatmentImage_height / 210) *
                                          111) + 'px',
                                  }"
                                >
                                  <p
                                    class="m-0"
                                    style="
                                      color: #ffffff;
                                      height: 33.5px;
                                      width: 62px;
                                      line-height: 35.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 33.5px;
                                      width: 62px;
                                      line-height: 35.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ result_Data[item].machine_status }}
                                  </p>
                                </div>
                                <div
                                  class="mx-auto my-2"
                                  style="position: absolute; right: 0px"
                                  :style="{
                                    top:
                                      (heatTreatmentImage_height < 126 ||
                                      heatTreatmentImage_height == undefined
                                        ? 126
                                        : (heatTreatmentImage_height / 210) *
                                          126) + 'px',
                                  }"
                                >
                                  <router-link
                                    class="router-link-decoration"
                                    :to="'machstatus'"
                                  >
                                    <button
                                      type="button"
                                      class="btn"
                                      style="
                                        width: 53px;
                                        height: 22px;
                                        line-height: 22px;
                                        padding: 0px;
                                        background-color: #4b8c80;
                                        color: #ffffff;
                                        border: 0px;
                                      "
                                      @click="
                                        set_deviceName(item),
                                          clearTimer(),
                                          sessionStorage.setItem(
                                            'mes_machStatus_previousPageName',
                                            ''
                                          ),
                                          sessionStorage.setItem(
                                            'mes_machStatus_this_device_name',
                                            item
                                          )
                                      "
                                    >
                                      明細
                                    </button>
                                  </router-link>
                                </div>
                              </div>
                              <b-row class="mx-0">
                                <b-col
                                  cols="12"
                                  class=""
                                  style="padding-right: 7.5%"
                                >
                                  <table style="width: 100%">
                                    <tr style="background-color: #e8e8ea">
                                      <td
                                        style="
                                          width: 70px;
                                          min-width: 70px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        設定值
                                      </td>
                                      <td
                                        v-for="(
                                          set_item, set_key
                                        ) in result_Data[item]
                                          .machine_detail_set"
                                        :key="set_key"
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        {{ set_item }}
                                      </td>
                                    </tr>
                                    <tr style="background-color: #fff">
                                      <td
                                        style="
                                          width: 70px;
                                          min-width: 70px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        實際值
                                      </td>
                                      <td
                                        v-for="(
                                          act_item, act_key
                                        ) in result_Data[item]
                                          .machine_detail_act"
                                        :key="act_key"
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                        :style="{
                                          'background-color':
                                            act_key == 2 ||
                                            act_key == 3 ||
                                            act_key == 12 ||
                                            act_key == 13 ||
                                            act_key == 17
                                              ? '#fff'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] >
                                                100
                                              ? result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  30 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  30 >
                                                  act_item
                                                ? '#fff' //暫時隱藏異常 #c10000
                                                : result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] +
                                                    15 <
                                                    act_item ||
                                                  result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] -
                                                    15 >
                                                    act_item
                                                ? '#fff' //暫時隱藏異常 #ffc100
                                                : '#fff'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] <
                                                1
                                              ? result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  0.1 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  0.1 >
                                                  act_item
                                                ? '#fff' //暫時隱藏異常 #c10000
                                                : result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] +
                                                    0.05 <
                                                    act_item ||
                                                  result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] -
                                                    0.05 >
                                                    act_item
                                                ? '#fff' //暫時隱藏異常 #ffc100
                                                : '#fff'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  20 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  20 >
                                                  act_item
                                              ? '#fff' //暫時隱藏異常 #c10000
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  10 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  10 >
                                                  act_item
                                              ? '#fff' //暫時隱藏異常 #ffc100
                                              : '#fff',
                                          color:
                                            act_key == 2 ||
                                            act_key == 3 ||
                                            act_key == 12 ||
                                            act_key == 13 ||
                                            act_key == 17
                                              ? '#4b8c80'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] >
                                                100
                                              ? result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  30 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  30 >
                                                  act_item
                                                ? '#4b8c80' //暫時隱藏異常 #fff
                                                : result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] +
                                                    15 <
                                                    act_item ||
                                                  result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] -
                                                    15 >
                                                    act_item
                                                ? '#4b8c80' //暫時隱藏異常 #646569
                                                : '#4b8c80'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] <
                                                1
                                              ? result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  0.1 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  0.1 >
                                                  act_item
                                                ? '#4b8c80' //暫時隱藏異常 #fff
                                                : result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] +
                                                    0.05 <
                                                    act_item ||
                                                  result_Data[item]
                                                    .machine_detail_set[
                                                    act_key
                                                  ] -
                                                    0.05 >
                                                    act_item
                                                ? '#4b8c80' //暫時隱藏異常 #646569
                                                : '#4b8c80'
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  20 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  20 >
                                                  act_item
                                              ? '#4b8c80' //暫時隱藏異常 #fff
                                              : result_Data[item]
                                                  .machine_detail_set[act_key] +
                                                  10 <
                                                  act_item ||
                                                result_Data[item]
                                                  .machine_detail_set[act_key] -
                                                  10 >
                                                  act_item
                                              ? '#4b8c80' //暫時隱藏異常 #646569
                                              : '#4b8c80',
                                        }"
                                      >
                                        {{ act_item }}
                                      </td>
                                    </tr>
                                  </table>
                                </b-col>
                              </b-row>
                              <hr
                                class="m-0"
                                style="border-top: 3px solid rgb(75, 140, 128)"
                              />
                            </template>
                            <template v-else>
                              <div
                                :style="{
                                  left: '0px',
                                  width: '100%',
                                  height:
                                    (heatTreatmentImage_height < 175 ||
                                    heatTreatmentImage_height == undefined
                                      ? 175
                                      : heatTreatmentImage_height - 50) + 'px',
                                  'background-color': 'rgb(100, 101, 105, .3)',
                                }"
                                style="position: absolute"
                              ></div>
                              <div
                                style="
                                  width: 100%;
                                  position: absolute;
                                  left: 0px;
                                "
                              >
                                <img
                                  :src="heatTreatmentImageA"
                                  alt=""
                                  style="width: 100%; height: auto"
                                />
                              </div>
                              <div
                                class="mx-auto my-2"
                                style="position: absolute; left: 12px"
                                :style="{
                                  top:
                                    (heatTreatmentImage_height < 111 ||
                                    heatTreatmentImage_height == undefined
                                      ? 111
                                      : (heatTreatmentImage_height / 210) *
                                        111) + 'px',
                                }"
                              >
                                <p
                                  class="m-0"
                                  style="
                                    background-color: #cccccc;
                                    color: #ffffff;
                                    height: 33.5px;
                                    width: 62px;
                                    line-height: 35.5px;
                                  "
                                >
                                  {{ item }}
                                </p>
                                <p
                                  class="m-0"
                                  style="
                                    background-color: #f2f2f2;
                                    color: #cccccc;
                                    height: 33.5px;
                                    width: 62px;
                                    line-height: 35.5px;
                                  "
                                >
                                  未導入
                                </p>
                              </div>
                              <div
                                class="mx-auto my-2"
                                style="position: absolute; right: 0px"
                                :style="{
                                  top:
                                    (heatTreatmentImage_height < 126 ||
                                    heatTreatmentImage_height == undefined
                                      ? 126
                                      : (heatTreatmentImage_height / 210) *
                                        126) + 'px',
                                }"
                              >
                                <button
                                  type="button"
                                  class="btn"
                                  style="
                                    width: 53px;
                                    height: 22px;
                                    line-height: 22px;
                                    padding: 0px;
                                    background-color: #cccccc;
                                    color: #ffffff;
                                    border: 0px;
                                    cursor: default;
                                  "
                                >
                                  明細
                                </button>
                              </div>
                              <b-row
                                class="mx-0"
                                :style="{
                                  'margin-top':
                                    (heatTreatmentImage_height < 210 ||
                                    heatTreatmentImage_height == undefined
                                      ? 210
                                      : heatTreatmentImage_height) + 'px',
                                }"
                              >
                                <b-col
                                  cols="12"
                                  class=""
                                  style="padding-right: 7.5%"
                                >
                                  <table style="width: 100%">
                                    <tr style="background-color: #e8e8ea">
                                      <td
                                        style="
                                          width: 70px;
                                          min-width: 70px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        設定值
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #646569;
                                        "
                                      >
                                        -
                                      </td>
                                    </tr>
                                    <tr style="background-color: #fff">
                                      <td
                                        style="
                                          width: 70px;
                                          min-width: 70px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        實際值
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                      <td
                                        style="
                                          width: 52px;
                                          min-width: 52px;
                                          border: 0.8pt solid #dcdcde;
                                          color: #4b8c80;
                                        "
                                      >
                                        -
                                      </td>
                                    </tr>
                                  </table>
                                </b-col>
                              </b-row>
                              <hr
                                class="m-0"
                                style="border-top: 3px solid rgb(75, 140, 128)"
                              />
                            </template>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab title="開機稼動率" lazy>
                        <b-row
                          class="mx-0"
                          ref="heatTreatment_detail_activation"
                        >
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="result_Data[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                                height: 250px;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        result_Data[item].machine_status ==
                                        '運作'
                                          ? '#00b152'
                                          : result_Data[item].machine_status ==
                                            '待機'
                                          ? '#ffc100'
                                          : result_Data[item].machine_status ==
                                            '異常'
                                          ? '#c10000'
                                          : result_Data[item].machine_status ==
                                            '維修'
                                          ? '#cccdfe'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      result_Data[item].machine_status == "運作"
                                        ? "運作"
                                        : result_Data[item].machine_status ==
                                          "待機"
                                        ? "待機"
                                        : result_Data[item].machine_status ==
                                          "異常"
                                        ? "異常"
                                        : result_Data[item].machine_status ==
                                          "維修"
                                        ? "維修"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                                style="align-self: center"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>
                                        {{
                                          result_Data[item].device_queue_time
                                        }}
                                      </span>
                                    </div>
                                    <div>
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(item),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                item
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                    </div>
                                  </b-col>
                                </b-row>

                                <b-row class="mx-0 my-2">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        result_Data[item].stack_bar_information
                                      "
                                      :stacksSize="'normal'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                                height: 250px;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    未導入
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                                style="align-self: center"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>待機時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0 my-2">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'normal'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                  <!-- 包裝 -->
                  <b-col
                    v-if="process == '包裝'"
                    cols="11"
                    class="px-0 elecboard-device-col"
                  >
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab title="包裝稼動率" lazy>
                        <b-row class="mx-0" ref="elecboard_detail_activation">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="6"
                            lg="6"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="
                                testPackage.package_activation[item] !=
                                undefined
                              "
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="2"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="2"
                                class="px-1 text-center"
                                style="align-self: center"
                              >
                                <div
                                  v-if="packageImg[item] == null"
                                  style="
                                    width: 70px;
                                    height: 80px;
                                    background-color: #cccccc;
                                  "
                                  class="mx-auto my-2"
                                ></div>
                                <div
                                  v-else
                                  style="width: 70px; height: 80px"
                                  class="mx-auto my-2"
                                >
                                  <img
                                    :src="packageImg[item]"
                                    alt=""
                                    style="
                                      width: 100%;
                                      height: 100%;
                                      object-position: left top;
                                      object-fit: cover;
                                    "
                                  />
                                </div>
                              </b-col>
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        testPackage.result_Data[item] ==
                                        undefined
                                          ? '#cccccc'
                                          : testPackage.result_Data[item]
                                              .machine_status == '運作'
                                          ? '#00b152'
                                          : testPackage.result_Data[item]
                                              .machine_status == '待機'
                                          ? '#ffc100'
                                          : testPackage.result_Data[item]
                                              .machine_status == '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        testPackage.result_Data[item] ==
                                        undefined
                                          ? '#cccccc'
                                          : testPackage.result_Data[item]
                                              .machine_status == '運作'
                                          ? '#00b152'
                                          : testPackage.result_Data[item]
                                              .machine_status == '待機'
                                          ? '#ffc100'
                                          : testPackage.result_Data[item]
                                              .machine_status == '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      testPackage.result_Data[item] == undefined
                                        ? "-"
                                        : testPackage.result_Data[item]
                                            .machine_status == "運作"
                                        ? "運作"
                                        : testPackage.result_Data[item]
                                            .machine_status == "待機"
                                        ? "待機"
                                        : testPackage.result_Data[item]
                                            .machine_status == "異常"
                                        ? "異常"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="7"
                                xl="8"
                                lg="8"
                                md="8"
                                sm="7"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>包裝時間:</span>
                                      <span>
                                        {{
                                          testPackage.site_activation[item] !=
                                          undefined
                                            ? testPackage.site_activation[item]
                                            : "0時0分"
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      v-if="
                                        testPackage.work_data[item] != undefined
                                      "
                                    >
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(
                                              JSON.stringify({
                                                work_code:
                                                  testPackage.work_data[item]
                                                    .work_code,
                                                product_line: item,
                                              })
                                            ),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                JSON.stringify({
                                                  work_code:
                                                    testPackage.work_data[item]
                                                      .work_code,
                                                  product_line: item,
                                                })
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                    </div>
                                    <div v-else>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>

                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="43200"
                                      :stacksData="
                                        testPackage.package_activation[item]
                                      "
                                      :stacksSize="'package-midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="2"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="2"
                                class="px-1 text-center"
                                style="align-self: center"
                                ><div
                                  v-if="packageImg[item] == null"
                                  style="
                                    width: 70px;
                                    height: 80px;
                                    background-color: #cccccc;
                                  "
                                  class="mx-auto my-2"
                                ></div>
                                <div
                                  v-else
                                  style="
                                    width: 70px;
                                    height: 80px;
                                    back-groundcolor: #cccccc;
                                  "
                                  class="mx-auto my-2"
                                >
                                  <img
                                    :src="packageImg[item]"
                                    alt=""
                                    style="
                                      width: 100%;
                                      height: 100%;
                                      object-position: left top;
                                      object-fit: cover;
                                    "
                                  />
                                </div>
                              </b-col>
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    -
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="7"
                                xl="8"
                                lg="8"
                                md="8"
                                sm="7"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>包裝時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="43200"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'package-midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab title="即時資訊" lazy>
                        <b-row class="mx-0" ref="elecboard_detail_now">
                          <template v-if="testPackage">
                            <b-col
                              v-for="(item, key) in show_device_list"
                              :key="key"
                              cols="12"
                              xl="6"
                              lg="6"
                              md="12"
                              sm="12"
                              class="px-0 elecboard-device-col"
                            >
                              <b-row
                                v-if="testPackage.work_data[item] != undefined"
                                class="mx-0 py-1"
                                style="
                                  color: #000000;
                                  font-size: 1.125rem;
                                  border: 1px solid #cccccc;
                                "
                                ><b-col
                                  cols="2"
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="2"
                                  class="px-1 text-center"
                                  style="align-self: center"
                                  ><div
                                    v-if="packageImg[item] == null"
                                    style="
                                      width: 70px;
                                      height: 80px;
                                      background-color: #cccccc;
                                    "
                                    class="mx-auto my-2"
                                  ></div>
                                  <div
                                    v-else
                                    style="
                                      width: 70px;
                                      height: 80px;
                                      back-groundcolor: #cccccc;
                                    "
                                    class="mx-auto my-2"
                                  >
                                    <img
                                      :src="packageImg[item]"
                                      alt=""
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-position: left top;
                                        object-fit: cover;
                                      "
                                    />
                                  </div>
                                </b-col>
                                <b-col
                                  cols="3"
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="3"
                                  class="px-3 text-center"
                                  style="align-self: center"
                                >
                                  <div class="mx-auto my-2">
                                    <p
                                      class="m-0"
                                      style="
                                        background-color: #cccccc;
                                        color: #ffffff;
                                        height: 40.5px;
                                        line-height: 40.5px;
                                      "
                                      :style="{
                                        'background-color':
                                          testPackage.result_Data[item]
                                            .machine_status == '運作'
                                            ? '#00b152'
                                            : testPackage.result_Data[item]
                                                .machine_status == '待機'
                                            ? '#ffc100'
                                            : testPackage.result_Data[item]
                                                .machine_status == '異常'
                                            ? '#c10000'
                                            : '#cccccc',
                                      }"
                                    >
                                      {{ item }}
                                    </p>
                                    <p
                                      class="m-0"
                                      style="
                                        background-color: #f2f2f2;
                                        height: 40.5px;
                                        line-height: 40.5px;
                                      "
                                      :style="{
                                        color:
                                          testPackage.result_Data[item]
                                            .machine_status == '運作'
                                            ? '#00b152'
                                            : testPackage.result_Data[item]
                                                .machine_status == '待機'
                                            ? '#ffc100'
                                            : testPackage.result_Data[item]
                                                .machine_status == '異常'
                                            ? '#c10000'
                                            : '#cccccc',
                                      }"
                                    >
                                      {{
                                        testPackage.result_Data[item]
                                          .machine_status == "運作"
                                          ? "運作"
                                          : testPackage.result_Data[item]
                                              .machine_status == "待機"
                                          ? "待機"
                                          : testPackage.result_Data[item]
                                              .machine_status == "異常"
                                          ? "異常"
                                          : "離線"
                                      }}
                                    </p>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="7"
                                  xl="8"
                                  lg="8"
                                  md="8"
                                  sm="7"
                                  class="pl-0 pr-3 my-2 text-left"
                                >
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工單號:</span>
                                        <span>{{
                                          testPackage.work_data[item].work_code
                                        }}</span>
                                      </div>
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工總支數:</span>
                                        <span>{{
                                          testPackage.work_data[
                                            item
                                          ].work_qty.toLocaleString("en-US")
                                        }}</span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>批號:</span>
                                        <span>{{
                                          testPackage.work_data[item].batch
                                        }}</span>
                                      </div>
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工總重量:</span>
                                        <span
                                          >{{
                                            testPackage.work_data[
                                              item
                                            ].total_weight.toLocaleString(
                                              "en-US"
                                            )
                                          }}KG</span
                                        >
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>包裝時間:</span>
                                        <span>{{
                                          testPackage.work_data[item].work_time
                                        }}</span>
                                      </div>
                                      <div>
                                        <router-link
                                          class="router-link-decoration"
                                          :to="'machstatus'"
                                        >
                                          <button
                                            type="button"
                                            class="btn"
                                            style="
                                              width: 53px;
                                              height: 22px;
                                              line-height: 22px;
                                              padding: 0px;
                                              background-color: #4b8c80;
                                              color: #ffffff;
                                              border: 0px;
                                            "
                                            @click="
                                              set_deviceName(
                                                JSON.stringify({
                                                  work_code:
                                                    testPackage.work_data[item]
                                                      .work_code,
                                                  product_line: item,
                                                })
                                              ),
                                                clearTimer(),
                                                sessionStorage.setItem(
                                                  'mes_machStatus_previousPageName',
                                                  ''
                                                ),
                                                sessionStorage.setItem(
                                                  'mes_machStatus_this_device_name',
                                                  JSON.stringify({
                                                    work_code:
                                                      testPackage.work_data[
                                                        item
                                                      ].work_code,
                                                    product_line: item,
                                                  })
                                                )
                                            "
                                          >
                                            明細
                                          </button>
                                        </router-link>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                              <b-row
                                v-else
                                class="mx-0 py-1"
                                style="
                                  color: #cccccc;
                                  font-size: 1.125rem;
                                  border: 1px solid #cccccc;
                                "
                                ><b-col
                                  cols="2"
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="2"
                                  class="px-1 text-center"
                                  style="align-self: center"
                                  ><div
                                    v-if="packageImg[item] == null"
                                    style="
                                      width: 70px;
                                      height: 80px;
                                      background-color: #cccccc;
                                    "
                                    class="mx-auto my-2"
                                  ></div>
                                  <div
                                    v-else
                                    style="
                                      width: 70px;
                                      height: 80px;
                                      back-groundcolor: #cccccc;
                                    "
                                    class="mx-auto my-2"
                                  >
                                    <img
                                      :src="packageImg[item]"
                                      alt=""
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-position: left top;
                                        object-fit: cover;
                                      "
                                    />
                                  </div>
                                </b-col>
                                <b-col
                                  cols="3"
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="3"
                                  class="px-3 text-center"
                                  style="align-self: center"
                                >
                                  <div class="mx-auto my-2">
                                    <p
                                      class="m-0"
                                      style="
                                        background-color: #cccccc;
                                        color: #ffffff;
                                        height: 40.5px;
                                        line-height: 40.5px;
                                      "
                                    >
                                      {{ item }}
                                    </p>
                                    <p
                                      class="m-0"
                                      style="
                                        background-color: #f2f2f2;
                                        color: #cccccc;
                                        height: 40.5px;
                                        line-height: 40.5px;
                                      "
                                    >
                                      -
                                    </p>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="7"
                                  xl="8"
                                  lg="8"
                                  md="8"
                                  sm="7"
                                  class="pl-0 pr-3 my-2 text-left"
                                >
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工單號:</span>
                                        <span>-</span>
                                      </div>
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工總支數:</span>
                                        <span>-</span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>批號:</span>
                                        <span>-</span>
                                      </div>
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>派工總重量:</span>
                                        <span>-</span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mx-0">
                                    <b-col
                                      cols="12"
                                      class="
                                        px-0
                                        d-flex
                                        justify-content-between
                                      "
                                    >
                                      <div
                                        style="
                                          overflow-x: hidden;
                                          white-space: nowrap;
                                        "
                                      >
                                        <span>包裝時間:</span>
                                        <span>-</span>
                                      </div>
                                      <div>
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #cccccc;
                                            color: #ffffff;
                                            border: 0px;
                                            cursor: default;
                                          "
                                        >
                                          明細
                                        </button>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </template>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                  <!-- 出貨 -->
                  <b-col
                    v-if="process == '出貨'"
                    cols="11"
                    class="px-0 elecboard-device-col"
                    style="overflow-x: auto"
                  >
                    <b-tabs class="customize-tab" v-model="tabIndex">
                      <b-tab title="出貨稼動率" lazy
                        ><b-row class="mx-0" ref="elecboard_detail_activation">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="
                                testContainerLoad_activation
                                  .container_activation[item] != undefined
                              "
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        testContainerLoad[item] == undefined
                                          ? '#cccccc'
                                          : testContainerLoad[item].status ==
                                            '裝櫃中'
                                          ? '#00b152'
                                          : testContainerLoad[item].status ==
                                            '待機'
                                          ? '#ffc100'
                                          : testContainerLoad[item].status ==
                                            '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        testContainerLoad[item] == undefined
                                          ? '#cccccc'
                                          : testContainerLoad[item].status ==
                                            '裝櫃中'
                                          ? '#00b152'
                                          : testContainerLoad[item].status ==
                                            '待機'
                                          ? '#ffc100'
                                          : testContainerLoad[item].status ==
                                            '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      testContainerLoad[item] == undefined
                                        ? "-"
                                        : testContainerLoad[item].status ==
                                          "裝櫃中"
                                        ? "裝櫃中"
                                        : testContainerLoad[item].status ==
                                          "待機"
                                        ? "待機"
                                        : testContainerLoad[item].status ==
                                          "異常"
                                        ? "異常"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>出貨時間:</span>
                                      <span>
                                        {{
                                          testContainerLoad_activation
                                            .wharf_run_time[item] != undefined
                                            ? testContainerLoad_activation
                                                .wharf_run_time[item]
                                            : "0時0分"
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      v-if="
                                        testContainerLoad[item] != undefined
                                      "
                                    >
                                      <router-link
                                        class="router-link-decoration"
                                        :to="'machstatus'"
                                      >
                                        <button
                                          type="button"
                                          class="btn"
                                          style="
                                            width: 53px;
                                            height: 22px;
                                            line-height: 22px;
                                            padding: 0px;
                                            background-color: #4b8c80;
                                            color: #ffffff;
                                            border: 0px;
                                          "
                                          @click="
                                            set_deviceName(
                                              item
                                            ),
                                              set_shipmentProcess(
                                                '裝櫃-即時狀態'
                                              ),
                                              clearTimer(),
                                              sessionStorage.setItem(
                                                'mes_machStatus_previousPageName',
                                                ''
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_this_device_name',
                                                testContainerLoad[item]
                                                  .sign_code
                                              ),
                                              sessionStorage.setItem(
                                                'mes_machStatus_shipmentProcess',
                                                '裝櫃-即時狀態'
                                              )
                                          "
                                        >
                                          明細
                                        </button>
                                      </router-link>
                                    </div>
                                    <div v-else>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>

                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="43200"
                                      :stacksData="
                                        testContainerLoad_activation
                                          .container_activation[item]
                                      "
                                      :stacksSize="'package-midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    -
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <span>出貨時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn"
                                        style="
                                          width: 53px;
                                          height: 22px;
                                          line-height: 22px;
                                          padding: 0px;
                                          background-color: #cccccc;
                                          color: #ffffff;
                                          border: 0px;
                                          cursor: default;
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mx-0">
                                  <b-col cols="12" class="px-0">
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="43200"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'package-midle'"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col> </b-row
                      ></b-tab>
                      <b-tab title="裝櫃-即時狀態" lazy>
                        <b-row class="mx-0" ref="elecboard_detail_now">
                          <b-col
                            v-for="(item, key) in show_device_list"
                            :key="key"
                            cols="12"
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              v-if="testContainerLoad[item] != undefined"
                              class="mx-0 py-1"
                              style="
                                color: #000000;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      'background-color':
                                        testContainerLoad[item].status ==
                                        '裝櫃中'
                                          ? '#00b152'
                                          : testContainerLoad[item].status ==
                                            '待機'
                                          ? '#ffc100'
                                          : testContainerLoad[item].status ==
                                            '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                    :style="{
                                      color:
                                        testContainerLoad[item].status ==
                                        '裝櫃中'
                                          ? '#00b152'
                                          : testContainerLoad[item].status ==
                                            '待機'
                                          ? '#ffc100'
                                          : testContainerLoad[item].status ==
                                            '異常'
                                          ? '#c10000'
                                          : '#cccccc',
                                    }"
                                  >
                                    {{
                                      testContainerLoad[item].status == "裝櫃中"
                                        ? "裝櫃中"
                                        : testContainerLoad[item].status ==
                                          "待機"
                                        ? "待機"
                                        : testContainerLoad[item].status ==
                                          "異常"
                                        ? "異常"
                                        : "離線"
                                    }}
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>包裝單號:</span>
                                        <span>{{
                                          testContainerLoad[item].sign_code
                                        }}</span>
                                      </div>
                                      <div>
                                        <span>總重:</span>
                                        <span>{{
                                          testContainerLoad[
                                            item
                                          ].total_weight.toLocaleString(
                                            "en-US"
                                          ) +
                                          " " +
                                          "KG"
                                        }}</span>
                                      </div>
                                      <div>
                                        <span>棧板數:</span>
                                        <span>
                                          {{
                                            testContainerLoad[item].total_plno
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>車牌:</span>
                                        <span>{{
                                          testContainerLoad[item].license_plate
                                        }}</span>
                                      </div>
                                    </div>
                                    <div
                                      style="
                                        text-align: right;
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>櫃號:</span>
                                        <span>{{
                                          testContainerLoad[item].container_no
                                        }}</span>
                                      </div>
                                      <div>
                                        <div>
                                          <router-link
                                            class="router-link-decoration"
                                            :to="'machstatus'"
                                          >
                                            <button
                                              type="button"
                                              class="btn"
                                              style="
                                                width: 53px;
                                                height: 22px;
                                                line-height: 22px;
                                                padding: 0px;
                                                background-color: #4b8c80;
                                                color: #ffffff;
                                                border: 0px;
                                                text-align: center;
                                              "
                                              @click="
                                                set_deviceName(
                                                  item
                                                ),
                                                  set_shipmentProcess(
                                                    '裝櫃-即時狀態'
                                                  ),
                                                  clearTimer(),
                                                  sessionStorage.setItem(
                                                    'mes_machStatus_previousPageName',
                                                    ''
                                                  ),
                                                  sessionStorage.setItem(
                                                    'mes_machStatus_this_device_name',
                                                    testContainerLoad[item]
                                                      .sign_code
                                                  ),
                                                  sessionStorage.setItem(
                                                    'mes_machStatus_shipmentProcess',
                                                    '裝櫃-即時狀態'
                                                  )
                                              "
                                            >
                                              明細
                                            </button>
                                          </router-link>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              v-else
                              class="mx-0 py-1"
                              style="
                                color: #cccccc;
                                font-size: 1.125rem;
                                border: 1px solid #cccccc;
                              "
                            >
                              <b-col
                                cols="3"
                                xl="2"
                                lg="2"
                                md="2"
                                sm="3"
                                class="px-3 text-center"
                                style="align-self: center"
                              >
                                <div class="mx-auto my-2">
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #cccccc;
                                      color: #ffffff;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    {{ item }}
                                  </p>
                                  <p
                                    class="m-0"
                                    style="
                                      background-color: #f2f2f2;
                                      color: #cccccc;
                                      height: 40.5px;
                                      line-height: 40.5px;
                                    "
                                  >
                                    -
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                cols="9"
                                xl="10"
                                lg="10"
                                md="10"
                                sm="9"
                                class="pl-0 pr-3 my-2 text-left"
                              >
                                <b-row class="mx-0">
                                  <b-col
                                    cols="12"
                                    class="px-0 d-flex justify-content-between"
                                  >
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>包裝單號:</span>
                                        <span>-</span>
                                      </div>
                                      <div>
                                        <span>總重:</span>
                                        <span>-</span>
                                      </div>
                                      <div>
                                        <span>棧板數:</span>
                                        <span> - </span>
                                      </div>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>車牌:</span>
                                        <span>-</span>
                                      </div>
                                    </div>
                                    <div
                                      style="
                                        overflow-x: hidden;
                                        white-space: nowrap;
                                      "
                                    >
                                      <div>
                                        <span>櫃號:</span>
                                        <span>-</span>
                                      </div>
                                      <div>
                                        <div>
                                          <button
                                            type="button"
                                            class="btn"
                                            style="
                                              width: 53px;
                                              height: 22px;
                                              line-height: 22px;
                                              padding: 0px;
                                              background-color: #cccccc;
                                              color: #ffffff;
                                              border: 0px;
                                              cursor: default;
                                            "
                                          >
                                            明細
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <!-- <b-tab title="齊貨狀態" lazy>
                        <b-row class="mx-0" ref="elecboard_shipment">
                          <b-col
                            cols="12"
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            class="px-0 elecboard-device-col"
                          >
                            <b-row
                              class="mx-0"
                              style="color: #cccccc; font-size: 1.125rem"
                            >
                              <b-table
                                :fields="testShipmentFields"
                                :items="testShipmentItems"
                                class="shipment-table"
                              >
                                <template #cell(ta_wgt)="data">{{
                                  data.value.toLocaleString("en-US")
                                }}</template>
                                <template #cell(detail)="data">
                                  <router-link
                                    class="router-link-decoration"
                                    :to="'machstatus'"
                                  >
                                    <button
                                      type="button"
                                      class="btn"
                                      style="
                                        width: 53px;
                                        height: 22px;
                                        line-height: 22px;
                                        padding: 0px;
                                        background-color: #4b8c80;
                                        color: #ffffff;
                                        border: 0px;
                                      "
                                      @click="
                                        set_deviceName(data.item.og),
                                          set_shipmentProcess('齊貨狀態'),
                                          clearTimer(),
                                          sessionStorage.setItem(
                                            'mes_machStatus_previousPageName',
                                            ''
                                          ),
                                          sessionStorage.setItem(
                                            'mes_machStatus_this_device_name',
                                            data.item.og.toString()
                                          ),
                                          sessionStorage.setItem(
                                            'mes_machStatus_shipmentProcess',
                                            '齊貨狀態'
                                          )
                                      "
                                    >
                                      明細
                                    </button>
                                  </router-link>
                                </template>
                              </b-table>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-tab> -->
                    </b-tabs>
                  </b-col>
                </b-row>
              </b-col>
              <b-col :cols="window_innerWidth > 672 ? 1 : 2">
                <b-col
                  cols="12"
                  class="text-center mb-3 px-0"
                  ref="elecboard_status_bar"
                >
                  即時狀態
                </b-col>
                <b-col
                  cols="12"
                  class="px-0 text-center"
                  :style="{
                    height: elecboard_detail_status_height + 'px',
                  }"
                >
                  <div class="mx-auto" style="width: 100%; height: 100%">
                    <div
                      v-for="(item, key) in totalDeviceStatus"
                      :key="key"
                      style="width: 100%"
                      :style="{
                        height:
                          item > 0
                            ? (elecboard_detail_status_height /
                                device_array.length) *
                                item <
                              50
                              ? 50 + 'px'
                              : (elecboard_detail_status_height /
                                  device_array.length) *
                                  item +
                                'px'
                            : 0,
                      }"
                      class="d-flex justify-content-center px-3"
                    >
                      <b-row
                        align-v="center"
                        style="
                          width: 50%;
                          height: 100%;
                          min-width: 3rem;
                          position: relative;
                          color: #ffffff;
                        "
                        :style="{
                          'background-color':
                            key == '運作'
                              ? '#00b152'
                              : key == '裝櫃中'
                              ? '#00b152'
                              : key == '待機'
                              ? '#ffc100'
                              : key == '異常'
                              ? '#c10000'
                              : key == '未導入'
                              ? '#d6d6d6'
                              : key == '維修'
                              ? '#cccdfe'
                              : key == '調車'
                              ? '#09b0ff'
                              : key == '短寸'
                              ? '#99f98c'
                              : '#cccccc',
                        }"
                      >
                        <template v-if="item != 0">
                          <b-col cols="12" class="px-0">
                            <div>{{ key }}</div>
                            <div>{{ item }}</div>
                          </b-col>
                        </template>
                      </b-row>
                    </div>
                  </div>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>

    </b-row>
  </div>
</template>

<script>
// import $ from "jquery";
import stackBar from "@/components/stackBar.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ElecBoard",
  data() {
    return {
      heatTest: [
        {
          work_code: "test001",
          last: {
            power_frequency: 60,
            speed: 207.5,
            zone_length: 11050,
            sensor_distance: 0,
            frequency_sensor_name: "quench_conv_freq",
            time: "2021-03-31 17:10:06.040",
            sensor: "RXWG9-80X1000X12_quench_furn_temp6",
          },
          first: {
            power_frequency: 60,
            speed: 207.5,
            zone_length: 11050,
            sensor_distance: 2500,
            frequency_sensor_name: "quench_conv_freq",
            time: "2021-03-31 17:10:06.040",
            sensor: "RXWG9-80X1000X12_quench_furn_temp6",
          },
        },
        {
          work_code: "test002",
          last: {
            power_frequency: 60,
            speed: 207.5,
            zone_length: 2780,
            sensor_distance: 954,
            frequency_sensor_name: "cln_af_conv_freq",
            time: "2021-03-31 17:10:06.040",
            sensor: "QXJ100_cln_af_temp",
          },
          first: {
            power_frequency: 60,
            speed: 207.5,
            zone_length: 13515,
            sensor_distance: 3230,
            frequency_sensor_name: "tempering_conv_freq",
            time: "2021-03-31 17:10:06.040",
            sensor: "RCWGA6-100X1200X15_tempering_furn_temp2",
          },
        },
      ],
      window_innerWidth: 0,
      elecboard_detail_status_height: 0,
      totalDeviceStatus: {
        異常: 0,
        維修: 0,
        調車: 0,
        待機: 0,
        短寸: 0,
        運作: 0,
        離線: 0,
        未導入: 0,
      },
      heatTreatmentImage2: require("../assets/heat-treatment2.png"),//有回火5區
      heatTreatmentImageD2: require("../assets/heat-treatmentD2.png"),//D2爐
      heatTreatmentImageA: require("../assets/heat-treatmentA.png"),//無烘乾，有回火5區
      heatTreatmentImageB: require("../assets/heat-treatmentB.png"),//無回火5區的(只到4區)
      heatTreatmentImageC: require("../assets/heat-treatmentC.png"),//C爐
      heatTreatmentImageD: require("../assets/heat-treatmentD.png"),//用無回火5區的(只到4區，且無焠火5.6區)
      heatTreatmentImageE: require("../assets/heat-treatmentE.png"),//E爐
      device_image: {},
      heatTreatmentImage_height: 0,
      heatTreatmentImage_Width: 0,
      imgWidth: 6600,
      imgHeight: 420,
      focusPlaceButtonSelect: 2,
      focusCircleButtonSelect: 2,
      focusDeviceButtonSelect: false,
      clickRight: true,
      smallClickRight: true,
      lightClickRight: true,
      autoPlus: null,
      autoSmallPlus: null,
      sensorLastData: null,
      slideshowPage: 0,
      sensorshowPage: 0,
      lightshowPage: 0,
      page: "home",
      pageTitle: {
        home: "電子看板",
      },
      sensorArrayPage: [],
      sensorData: {},
      allAbnormal: [],
      stacksBarDefault: {
        "-": [
          {
            status: null,
            endTime: "2021-02-17 08:00:00",
            alarmDetail: "",
            startTime: "2021-02-17 08:00:00",
            duration_number: 0,
            stacksBarNumber: [
              "08",
              "09",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "00",
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
            ],
          },
        ],
      },
      device_stackBar: {},
      sensorEventStrArr: [],
      result_Data: {
        // C2: {
        // machine_detail_act: {
        //   cln_bf_temp: "-",
        //   dryer_cln_bf_temp: "-",
        //   quench_furn_temp1: "-",
        //   quench_furn_temp2: "-",
        //   quench_furn_temp3: "-",
        //   cp1: "-",
        //   quench_furn_temp4: "-",
        //   quench_furn_temp5: "-",
        //   cp2: "-",
        //   quench_furn_temp6: "-",
        //   quench_tank_temp: "-",
        //   cln_af_temp: "-",
        //   tempering_furn_temp1: "-",
        //   tempering_furn_temp2: "-",
        //   tempering_furn_temp3: "-",
        //   tempering_furn_temp4: "-",
        //   tempering_furn_temp5: "-",
        //   carb_tank_temp: "-",
        //   dryer_temp: "-",
        // },
        // },
      },
      // counter: {
      //   F07: { count: "--", percent: "--" },
      //   F12: { count: "--", percent: "--" },
      //   R01: { count: "--", percent: "--", remain_count: "--" },
      //   R02: { count: "--", percent: "--", remain_count: "--" },
      //   R03: { count: "--", percent: "--", remain_count: "--" },
      //   R05: { count: "--", percent: "--", remain_count: "--" },
      //   R06: { count: "--", percent: "--", remain_count: "--" },
      //   R09: { count: "--", percent: "--", remain_count: "--" },
      //   R12: { count: "--", percent: "--", remain_count: "--" },
      //   R13: { count: "--", percent: "--", remain_count: "--" },
      //   R14: { count: "--", percent: "--", remain_count: "--" },
      // },
      nowtime: "--",
      process_id: "",
      process: "",
      group_id: "",
      group_name: "",
      device_array: [],
      show_device_list: [],
      tabIndex: 0,
      user_array: [],
      query_time: null,
      query_counter: 0,
      ht_work_display: [],
      testPackage: {
        result_Data: {},
        work_data: {},
        site_activation: {},
        package_activation: {},
      },
      packageImg: {
        "01": require("../assets/包裝第一組組長-陳文選.jpg"),
        "02": require("../assets/包裝第二組組長-王煦妍.jpg"),
        "03": require("../assets/包裝第三組組長-李美敏.jpg"),
        "04": require("../assets/包裝第四組組長-陳進茂.jpg"),
        "05": require("../assets/包裝第五組組長-陳維新.jpg"),
        "06": null,
        "07": require("../assets/包裝第七組組長-張子浩.jpg"),
        "08": null,
        "09": null,
        10: require("../assets/包裝第十組組長-陳美玲.jpg"),
        11: null,
        12: null,
      },
      testContainerLoad: {},
      testContainerLoad_activation: {
        container_activation: {},
        wharf_run_time: {},
      },
      testShipmentFields: [
        {
          key: "ship_date",
          label: "預計出貨日",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "og",
          label: "OG單號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "cno",
          label: "櫃號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        // {
        //   key: "car_no",
        //   label: "車牌號碼",
        //   sortable: false,
        //   class: "font-family-dfyuanstd-w5 table-col-hight",
        // },
        {
          key: "ta_wgt",
          label: "OG總重量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "unstock_wgt",
          label: "未入庫重量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "pallet",
          label: "總板數",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "box_qty",
          label: "總箱數",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "detail",
          label: "",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight",
        },
      ],
      testShipmentItems: [],
    };
  },
  created: function () {
    // window.addEventListener("resize", this.onResize_elecboard);
    window.addEventListener("beforeunload", this.setSessionItems);
    this.process_id = sessionStorage.getItem("mes_elecboard_process_id");
    this.group_id = sessionStorage.getItem("mes_elecboard_group_id");
    this.tabIndex = sessionStorage.getItem("mes_elecboard_tabIndex");
    if (this.process_id != undefined && this.group_id != undefined) {
      this.set_sideBarSelect(["elecboard", this.process_id, this.group_id]);
    } else if (this.sideBarSelect == null) {
      this.set_sideBarSelect(["elecboard", "heading", "heading4"]);
    } else if (this.sideBarSelect.page != "elecboard") {
      this.set_sideBarSelect(["elecboard", "heading", "heading4"]);
    } else {
      this.set_elecboard_group();
    }
    this.change_selectPage("elecboard");
    this.change_selectPageName(this.pageName.elecboard);
    window.addEventListener("resize", this._onResize_elecboard);
    sessionStorage.removeItem("mes_elecboard_process_id");
    sessionStorage.removeItem("mes_elecboard_group_id");
    sessionStorage.removeItem("mes_elecboard_tabIndex");
  },
  mounted: function () {
    // this.getNowTime();
    this.sideBarSelect.change = Math.random();

    // console.log(this.$refs.elecboard_detail.clientHeight);
    // this.elecboard_detail_status_height = this.$refs.elecboard_detail.clientHeight;
  },
  components: {
    stackBar,
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        // vm.clearTimer();
        console.log(vm.group_id);
        if (vm.group_id != vm.sideBarSelect.group.id) {
          vm.reset([""]);
        } else {
          vm.reset(["tabIndex"]);
        }
        vm.set_elecboard_group();
        vm.getMachineData();
        // vm.onResize_elecboard();
        vm._onResize_elecboard();
      },
      deep: true,
    },
    tabIndex: {
      handler() {
        let vm = this;
        console.log(vm.tabIndex);
        vm._onResize_elecboard();
      },
    },
    query_counter: {
      handler() {
        let vm = this;
        if (vm.query_counter >= 1500) {
          window.location.reload();
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
      stacksBarClass: "stackBar/get_stacksBarClass",
      stacksBarMaxValue: "stackBar/get_stacksBarMaxValue",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_deviceName: "selectDevice/set_deviceName",
      set_shipmentProcess: "selectDevice/set_shipmentProcess",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
    }),
    // onResize_elecboard() {
    //   let vm = this;
    //   vm.window_innerWidth = window.innerWidth;
    //   setTimeout(() => {
    //     vm.elecboard_detail_status_height =
    //       vm.$refs.elecboard_detail.clientHeight -
    //       vm.$refs.elecboard_status_bar.clientHeight -
    //       16;
    //   }, 0);
    // },
    _onResize_elecboard() {
      let vm = this;
      vm.window_innerWidth = window.innerWidth;
      vm._onResize_elecboard_detail_list();
      setTimeout(() => {
        vm._onResize_elecboard_status_bar();
      }, 0);
    },
    _onResize_elecboard_detail_list() {
      let vm = this;
      let show_device_list = [];
      if (vm.process == "熱處理" || vm.process == "出貨") {
        show_device_list = vm.device_array;
        vm.show_device_list = show_device_list;
        return;
      }
      if (vm.window_innerWidth > 1480) {
        let divisor = Math.round(vm.device_array.length / 2);
        vm.device_array.forEach((data, index) => {
          if (index < divisor) {
            show_device_list[index * 2] = data;
          } else {
            show_device_list[(index - divisor) * 2 + 1] = data;
          }
        });
      } else {
        show_device_list = vm.device_array;
      }
      vm.show_device_list = show_device_list;
    },
    _onResize_elecboard_status_bar() {
      let vm = this;

      let elecboard_detail = 0;
      if (vm.process == "熱處理") {
        if (vm.tabIndex == 0) {
          vm.heatTreatmentImage_height =
            vm.$refs.heatTreatmentImage_detail.childNodes[2].childNodes[2].childNodes[0].clientHeight; //圖片高度
          vm.heatTreatmentImage_Width =
            vm.$refs.heatTreatmentImage_detail.clientWidth;
          if (vm.window_innerWidth < 1480) {
            vm.elecboard_detail_status_height =
              vm.$refs.heatTreatmentImage_detail.clientHeight -
              vm.$refs.elecboard_status_bar.clientHeight -
              16 +
              42 +
              vm.$refs.group_title.clientHeight;
          } else {
            vm.elecboard_detail_status_height =
              vm.$refs.heatTreatmentImage_detail.clientHeight + 2;
          }
        } else if (vm.tabIndex == 1) {
          elecboard_detail =
            vm.$refs.heatTreatment_detail_activation.clientHeight;
          if (vm.window_innerWidth < 1480) {
            vm.elecboard_detail_status_height =
              elecboard_detail -
              vm.$refs.elecboard_status_bar.clientHeight -
              16 +
              42 +
              vm.$refs.group_title.clientHeight;
          } else {
            elecboard_detail =
              vm.$refs.heatTreatment_detail_activation.clientHeight;
            vm.elecboard_detail_status_height = elecboard_detail;
          }
        }
      } else if (vm.process == "出貨") {
        if (vm.tabIndex == 0) {
          elecboard_detail = vm.$refs.elecboard_detail_activation.clientHeight;
        } else if (vm.tabIndex == 1) {
          elecboard_detail = vm.$refs.elecboard_detail_now.clientHeight;
        } else if (vm.tabIndex == 2) {
          elecboard_detail = vm.$refs.elecboard_shipment.clientHeight;
        }
        if (vm.window_innerWidth < 1480) {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42 +
            vm.$refs.group_title.clientHeight;
        } else {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42;
        }
      } else if (vm.process == "包裝") {
        if (vm.tabIndex == 0) {
          elecboard_detail = vm.$refs.elecboard_detail_activation.clientHeight;
        } else if (vm.tabIndex == 1) {
          elecboard_detail = vm.$refs.elecboard_detail_now.clientHeight;
        }
        if (vm.window_innerWidth < 1480) {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42 +
            vm.$refs.group_title.clientHeight;
        } else {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42;
        }
      } else {
        if (vm.tabIndex == 0) {
          elecboard_detail = vm.$refs.elecboard_detail_now.clientHeight;
        } else if (vm.tabIndex == 1) {
          elecboard_detail = vm.$refs.elecboard_detail_activation.clientHeight;
        }
        if (vm.window_innerWidth < 1480) {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42 +
            vm.$refs.group_title.clientHeight;
        } else {
          vm.elecboard_detail_status_height =
            elecboard_detail -
            vm.$refs.elecboard_status_bar.clientHeight -
            16 +
            42;
        }
      }
    },
    set_elecboard_group() {
      let vm = this;
      let sideBarSelect = vm.sideBarSelect;
      if (sideBarSelect.process.id) {
        vm.process_id = sideBarSelect.process.id;
      }
      if (sideBarSelect.process.name) {
        vm.process = sideBarSelect.process.name;
      }
      if (sideBarSelect.group.id) {
        vm.group_id = sideBarSelect.group.id;
      }
      if (sideBarSelect.group.name) {
        vm.group_name = sideBarSelect.group.name;
      }
      if (sideBarSelect.group.device) {
        vm.device_array = sideBarSelect.group.device;
      }
      if (sideBarSelect.group.user) {
        if (vm.process == "熱處理") {
          sideBarSelect.group.user.forEach((data) => {
            vm.user_array.push({
              name: data.name,
              position: data.position,
              image: require("../assets/" + data.image),
              class: data.class,
            });
          });
        } else {
          sideBarSelect.group.user.forEach((data) => {
            vm.user_array.push({
              name: data.name,
              position: data.position,
              image: require("../assets/" + data.image),
            });
          });
        }
      }
    },
    getTotalDeviceStatus() {
      let vm = this;
      let totalDeviceStatus = {};
      vm.device_array.forEach((device_name) => {
        if (vm.result_Data[device_name] != undefined) {
          let machine_status = vm.result_Data[device_name].machine_status;
          if (machine_status == "-") {
            if (totalDeviceStatus["離線"] == undefined) {
              totalDeviceStatus["離線"] = 0;
            }
            totalDeviceStatus["離線"]++;
          } else if (machine_status == "異常") {
            if (totalDeviceStatus["異常"] == undefined) {
              totalDeviceStatus["異常"] = 0;
            }
            totalDeviceStatus["異常"]++;
          } else if (machine_status == "待機") {
            if (totalDeviceStatus["待機"] == undefined) {
              totalDeviceStatus["待機"] = 0;
            }
            totalDeviceStatus["待機"]++;
          } else if (machine_status == "運作") {
            if (totalDeviceStatus["運作"] == undefined) {
              totalDeviceStatus["運作"] = 0;
            }
            totalDeviceStatus["運作"]++;
          } else if (machine_status == "維修") {
            if (totalDeviceStatus["維修"] == undefined) {
              totalDeviceStatus["維修"] = 0;
            }
            totalDeviceStatus["維修"]++;
          } else if (machine_status == "調車") {
            if (totalDeviceStatus["調車"] == undefined) {
              totalDeviceStatus["調車"] = 0;
            }
            totalDeviceStatus["調車"]++;
          } else if (machine_status == "短寸") {
            if (totalDeviceStatus["短寸"] == undefined) {
              totalDeviceStatus["短寸"] = 0;
            }
            totalDeviceStatus["短寸"]++;
          }
        } else {
          if (totalDeviceStatus["未導入"] == undefined) {
            totalDeviceStatus["未導入"] = 0;
          }
          totalDeviceStatus["未導入"]++;
        }
      });
      console.log(totalDeviceStatus);
      vm.totalDeviceStatus = {};
      if (totalDeviceStatus["異常"] != undefined) {
        vm.totalDeviceStatus["異常"] = totalDeviceStatus["異常"];
      }
      if (totalDeviceStatus["維修"] != undefined) {
        vm.totalDeviceStatus["維修"] = totalDeviceStatus["維修"];
      }
      if (totalDeviceStatus["調車"] != undefined) {
        vm.totalDeviceStatus["調車"] = totalDeviceStatus["調車"];
      }
      if (totalDeviceStatus["待機"] != undefined) {
        vm.totalDeviceStatus["待機"] = totalDeviceStatus["待機"];
      }
      if (totalDeviceStatus["短寸"] != undefined) {
        vm.totalDeviceStatus["短寸"] = totalDeviceStatus["短寸"];
      }
      if (totalDeviceStatus["運作"] != undefined) {
        vm.totalDeviceStatus["運作"] = totalDeviceStatus["運作"];
      }
      if (totalDeviceStatus["離線"] != undefined) {
        vm.totalDeviceStatus["離線"] = totalDeviceStatus["離線"];
      }
      if (totalDeviceStatus["未導入"] != undefined) {
        vm.totalDeviceStatus["未導入"] = totalDeviceStatus["未導入"];
      }

      if (vm.process == "包裝") {
        totalDeviceStatus = {};
        vm.device_array.forEach((device_name) => {
          if (vm.testPackage.result_Data[device_name] != undefined) {
            let machine_status =
              vm.testPackage.result_Data[device_name].machine_status;
            if (machine_status == "-") {
              if (totalDeviceStatus["離線"] == undefined) {
                totalDeviceStatus["離線"] = 0;
              }
              totalDeviceStatus["離線"]++;
            } else if (machine_status == "異常") {
              if (totalDeviceStatus["異常"] == undefined) {
                totalDeviceStatus["異常"] = 0;
              }
              totalDeviceStatus["異常"]++;
            } else if (machine_status == "待機") {
              if (totalDeviceStatus["待機"] == undefined) {
                totalDeviceStatus["待機"] = 0;
              }
              totalDeviceStatus["待機"]++;
            } else if (machine_status == "運作") {
              if (totalDeviceStatus["運作"] == undefined) {
                totalDeviceStatus["運作"] = 0;
              }
              totalDeviceStatus["運作"]++;
            }
          } else {
            if (totalDeviceStatus["離線"] == undefined) {
              totalDeviceStatus["離線"] = 0;
            }
            totalDeviceStatus["離線"]++;
          }
        });
        console.log(totalDeviceStatus);
        vm.totalDeviceStatus = {};
        if (totalDeviceStatus["離線"] != undefined) {
          vm.totalDeviceStatus["離線"] = totalDeviceStatus["離線"];
        }
        if (totalDeviceStatus["異常"] != undefined) {
          vm.totalDeviceStatus["異常"] = totalDeviceStatus["異常"];
        }
        if (totalDeviceStatus["待機"] != undefined) {
          vm.totalDeviceStatus["待機"] = totalDeviceStatus["待機"];
        }
        if (totalDeviceStatus["運作"] != undefined) {
          vm.totalDeviceStatus["運作"] = totalDeviceStatus["運作"];
        }
      } else if (vm.process == "出貨") {
        totalDeviceStatus = {};
        vm.device_array.forEach((device_name) => {
          if (vm.testContainerLoad[device_name] != undefined) {
            let status = vm.testContainerLoad[device_name].status;
            if (status == "-") {
              if (totalDeviceStatus["離線"] == undefined) {
                totalDeviceStatus["離線"] = 0;
              }
              totalDeviceStatus["離線"]++;
            } else if (status == "裝櫃中") {
              if (totalDeviceStatus["裝櫃中"] == undefined) {
                totalDeviceStatus["裝櫃中"] = 0;
              }
              totalDeviceStatus["裝櫃中"]++;
            }
          } else {
            if (totalDeviceStatus["離線"] == undefined) {
              totalDeviceStatus["離線"] = 0;
            }
            totalDeviceStatus["離線"]++;
          }
        });

        vm.totalDeviceStatus = {};
        if (totalDeviceStatus["離線"] != undefined) {
          vm.totalDeviceStatus["離線"] = totalDeviceStatus["離線"];
        }
        if (totalDeviceStatus["裝櫃中"] != undefined) {
          vm.totalDeviceStatus["裝櫃中"] = totalDeviceStatus["裝櫃中"];
        }
      }
    },
    getMachineData() {
      let vm = this;
      if (vm.selectPage != "elecboard") {
        return;
      }
      this.clearTimer();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      params["process"] = vm.process;
      params["group_name"] = vm.group_name;
      vm.query_time = new Date();
      vm.axiosAction(params).then(() => {
        vm.searching = false;
        var result = vm.axiosResult;
        console.log(result);
        if (result.Response == "ok") {
          let result_data = result["QueryTableData"];
          if (vm.process == "包裝") {
            vm.testPackage["result_Data"] = result_data["device_status"];
            vm.testPackage["work_data"] = result_data["work_status"];
            vm.testPackage["package_activation"] =
              result_data["package_activation"];
            vm.testPackage["site_activation"] = result_data["site_activation"];

            let packageWorkStatus = {};
            let siteLine = "";

            vm.testPackage["work_data"] = result_data["work_status"];
          } else if (vm.process == "出貨") {
            vm.testContainerLoad = result_data["container_loading"];
            vm.testContainerLoad_activation.container_activation =
              result_data["container_activation"];
            vm.testContainerLoad_activation.wharf_run_time =
              result_data["wharf_run_time"];
            vm.testShipmentItems = result_data["container_shipment"];
            console.log(vm.testContainerLoad_activation.container_activation);
          } else {
            let result_Data_device = Object.keys(vm.result_Data);
            if (result_Data_device.length != result_data.length) {
              vm.result_Data = {};
            }
            for (let i = 0; i < result_data.length; i++) {
              vm.result_Data[result_data[i]["device_name"]] = result_data[i];
            }
          }
          vm.getTotalDeviceStatus();
          vm.obHeatTreatmentWork();
        }
        vm.query_counter++;
        vm.getNowTime();
        if (vm.query_time != null) {
          vm.query_time = null;
          if (vm.process == "熱處理") {
            setTimeout(function () {
              vm.getMachineData();
            }, 1000);
          } else {
            setTimeout(function () {
              vm.getMachineData();
            }, 1000);
          }
        }
      });
    },
    clearTimer() {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        //清除所有計時資料
        clearInterval(i);
      }
      // if (this.selectPage == "elecboard") {
      //   this.getNowTime();
      // }
    },
    getNowTime() {
      let vm = this;
      let Today = new Date();
      vm.nowtime =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
      console.log(vm.nowtime);
      // vm.elecboard_detail_height = this.$refs.elecboard_detail.clientHeight;

      // setTimeout(function () {
      //   vm.getNowTime();
      // }, 1000);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
    obHeatTreatmentWork() {
      let vm = this;
      if (vm.process == "熱處理") {
        let sensorZoneView = {
          GEI80: {
            width: 5,
            accumulate: 0,
          },
          QXJ80: {
            width: 9,
            accumulate: 5,
          },
          "RXWG9-80X1000X12": {
            width: 29,
            accumulate: 14,
          },
          TSW100: {
            width: 13,
            accumulate: 43,
          },
          QXJ100: {
            width: 8,
            accumulate: 56,
          },
          "RCWGA6-100X1200X15": {
            width: 34,
            accumulate: 64,
          }
        };
        let ht_work_display_data = [];
        let result_Data_Key = Object.keys(vm.result_Data);
        result_Data_Key.forEach((item) => {
          if (!ht_work_display_data[item]) {
            ht_work_display_data[item] = {
              work_schedule: [],
              transition: false,
            };
          }
          if (
            vm.result_Data[item].hasOwnProperty("work_schedule") &&
            vm.result_Data[item].work_schedule.length > 0
          ) {
            vm.result_Data[item].work_schedule.forEach(
              (workItem, workIndex) => {
                if (workItem.product_line == 0) {
                  //收料區出料
                  if (workItem.first) {
                    if (workItem.last) {
                      let firstSensorPoint = workItem.first.sensor.split("_");
                      let firstPosition =
                        workItem.first.sensor_distance /
                        workItem.first.zone_length;

                      let lastSensorPoint = workItem.last.sensor.split("_");
                      let lastPosition =
                        workItem.last.sensor_distance /
                        workItem.last.zone_length;

                      let firstPoint =
                        sensorZoneView[firstSensorPoint[0]].width *
                          firstPosition +
                        sensorZoneView[firstSensorPoint[0]].accumulate;

                      let lastPoint =
                        sensorZoneView[lastSensorPoint[0]].width *
                          lastPosition +
                        sensorZoneView[lastSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: Number(firstPoint.toFixed(2)),
                        last: Number(lastPoint.toFixed(2)),
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    } else {
                      let firstSensorPoint = workItem.first.sensor.split("_");
                      let firstPosition =
                        workItem.first.sensor_distance /
                        workItem.first.zone_length;

                      let firstPoint =
                        sensorZoneView[firstSensorPoint[0]].width *
                          firstPosition +
                        sensorZoneView[firstSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: Number(firstPoint.toFixed(2)),
                        last: 0,
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    }
                  } else {
                    if (workItem.last) {
                      let lastSensorPoint = workItem.last.sensor.split("_");
                      let lastPosition =
                        workItem.last.sensor_distance /
                        workItem.last.zone_length;

                      let lastPoint =
                        sensorZoneView[lastSensorPoint[0]].width *
                          lastPosition +
                        sensorZoneView[lastSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: 100,
                        last: Number(lastPoint.toFixed(2)),
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    } else {
                      if (vm.result_Data[item].hasOwnProperty("work_in_time")) {
                        if (vm.result_Data[item].work_in_time[workIndex].first != "" && vm.result_Data[item].work_in_time[workIndex].last == "") {
                          let work_code_obj = {
                            first: 100,
                            last: 0,
                            work_code:
                              vm.result_Data[item].work_schedule[workIndex]
                                .work_code,
                            org_code:
                              vm.result_Data[item].work_schedule[workIndex]
                                .work_org_code,
                          };
                          ht_work_display_data[item].work_schedule.push(
                            work_code_obj
                          );
                        }
                      }
                    }
                  }
                } else if (workItem.product_line == 1) {
                  //回火區結束出料
                  if (workItem.first) {
                    if (workItem.last) {
                      let firstSensorPoint = workItem.first.sensor.split("_");
                      let firstPosition =
                        workItem.first.sensor_distance /
                        workItem.first.zone_length;

                      let lastSensorPoint = workItem.last.sensor.split("_");
                      let lastPosition =
                        workItem.last.sensor_distance /
                        workItem.last.zone_length;

                      let firstPoint =
                        sensorZoneView[firstSensorPoint[0]].width *
                          firstPosition +
                        sensorZoneView[firstSensorPoint[0]].accumulate;

                      let lastPoint =
                        sensorZoneView[lastSensorPoint[0]].width *
                          lastPosition +
                        sensorZoneView[lastSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: Number(firstPoint.toFixed(2)),
                        last: Number(lastPoint.toFixed(2)),
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    } else {
                      let firstSensorPoint = workItem.first.sensor.split("_");
                      let firstPosition =
                        workItem.first.sensor_distance /
                        workItem.first.zone_length;

                      let firstPoint =
                        sensorZoneView[firstSensorPoint[0]].width *
                          firstPosition +
                        sensorZoneView[firstSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: Number(firstPoint.toFixed(2)),
                        last: 0,
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    }
                  } else {
                    if (workItem.last) {
                      let lastSensorPoint = workItem.last.sensor.split("_");
                      let lastPosition =
                        workItem.last.sensor_distance /
                        workItem.last.zone_length;

                      let lastPoint =
                        sensorZoneView[lastSensorPoint[0]].width *
                          lastPosition +
                        sensorZoneView[lastSensorPoint[0]].accumulate;

                      let work_code_obj = {
                        first: 80,
                        last: Number(lastPoint.toFixed(2)),
                        work_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_code,
                        org_code:
                          vm.result_Data[item].work_schedule[workIndex]
                            .work_org_code,
                      };
                      ht_work_display_data[item].work_schedule.push(
                        work_code_obj
                      );
                    } else {
                      if (vm.result_Data[item].hasOwnProperty("work_in_time")) {
                        if (vm.result_Data[item].work_in_time[workIndex].first != "" && vm.result_Data[item].work_in_time[workIndex].last == "") {
                          let work_code_obj = {
                            first: 100,
                            last: 0,
                            work_code:
                              vm.result_Data[item].work_schedule[workIndex]
                                .work_code,
                            org_code:
                              vm.result_Data[item].work_schedule[workIndex]
                                .work_org_code,
                          };
                          ht_work_display_data[item].work_schedule.push(
                            work_code_obj
                          );
                        }
                      }
                    }
                  }
                }
              }
            );
          } else if (
            vm.result_Data[item].hasOwnProperty("work_schedule") &&
            vm.result_Data[item].work_schedule.length == 0 &&
            vm.result_Data[item].hasOwnProperty("work_in_time")
          ) {
            vm.result_Data[item].work_in_time.forEach(
              (work_in_time_item, work_in_time_index) => {
                if (
                  work_in_time_item.start != "" &&
                  work_in_time_item.end == ""
                ) {
                  if (work_in_time_item.product_line == 0) {
                    let work_code_obj = {
                      first: 100,
                      last: 0,
                      work_code:
                        vm.result_Data[item].work_in_time[work_in_time_index]
                          .work_code,
                      org_code:
                        vm.result_Data[item].work_in_time[work_in_time_index]
                          .org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  } else if (work_in_time_item.product_line == 1) {
                    let work_code_obj = {
                      first: 80,
                      last: 0,
                      work_code:
                        vm.result_Data[item].work_in_time[work_in_time_index]
                          .work_code,
                      org_code:
                        vm.result_Data[item].work_in_time[work_in_time_index]
                          .org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  }
                }
              }
            );
          }
        });
        result_Data_Key.forEach((item) => {
          if (vm.ht_work_display[item]) {
            let last_work_code_count =
              vm.ht_work_display[item].work_schedule.length;
            let this_work_code_count =
              ht_work_display_data[item].work_schedule.length;
            if (last_work_code_count != this_work_code_count) {
              ht_work_display_data[item].transition = false;
            } else {
              ht_work_display_data[item].transition = true;
            }
          }
          ht_work_display_data[item].work_schedule.sort(vm.htWorkScheduleSort);
        });
        vm.ht_work_display = ht_work_display_data;

        let device_image = {};
        result_Data_Key.forEach((item) => {
          device_image[item] = vm[vm.result_Data[item].device_image];
        });
        vm.device_image = device_image;
      } else {
        return;
      }
    },
    htWorkScheduleSort(x, y) {
      return x.first == y.first ? 0 : x.first > y.first ? 1 : -1;
    },
    setSessionItems() {
      sessionStorage.setItem("mes_elecboard_process_id", this.process_id);
      sessionStorage.setItem("mes_elecboard_group_id", this.group_id);
      sessionStorage.setItem("mes_elecboard_tabIndex", this.tabIndex);
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
    window.removeEventListener("resize", this._onResize_elecboard);
    sessionStorage.setItem("mes_machStatus_previousPageName", "");
    this.clearTimer();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.elecboard-progress-bar-text {
  white-space: nowrap;
  position: absolute;
  left: 2%;
  top: 50%;
  transform: translate(0%, -50%);
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.elecboard-progress-bar-height {
  height: 27px;
}
@media screen and (max-width: 1480px) {
  .elecboard-group-img {
    display: none;
  }
  .elecboard-device-col {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 500px;
  }
}
.progress {
  background-color: #cdcbcb;
}
</style>
<style lang="scss">
.router-link-decoration:hover {
  text-decoration: none;
}
.nav-tabs .nav-link {
  width: 140px;
  margin-left: 0.15rem;
  border-radius: 0.75rem 0.75rem 0 0;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .show > .nav-link {
  background-color: #4b8c80;
  color: #ffffff;
}
.nav-tabs .nav-link,
.nav-tabs .show > .nav-link {
  background-color: #999999;
  color: #ffffff;
}
.nav-tabs > .nav-item > a {
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
}
.nav-tabs {
  border-bottom: none;
}

.elecboard-popover.popover {
  max-width: unset;
}
.elecboard-popover > .popover-body {
  background-color: rgba(50, 50, 50, 0.7);
  color: #ffffff;
}
.elecboard-popover > .arrow::after {
  border-top-color: rgba(50, 50, 50, 0.7);
  border-bottom-color: rgba(50, 50, 50, 0.7);
}
.shipment-table {
  min-width: 800px;
  border: #cccccc 1px solid;
}
.shipment-table th {
  background-color: #cccccc;
}
.shipment-table tr td:nth-child(1),
.shipment-table th td:nth-child(1) {
  width: 15%;
}
.shipment-table tr td:nth-child(2),
.shipment-table th td:nth-child(2) {
  width: 15%;
}
.shipment-table tr td:nth-child(3),
.shipment-table th td:nth-child(3) {
  width: 15%;
}
.shipment-table tr td:nth-child(4),
.shipment-table th td:nth-child(4) {
  width: 15%;
}
.shipment-table tr td:nth-child(5),
.shipment-table th td:nth-child(5) {
  width: 10%;
}
.shipment-table tr td:nth-child(6),
.shipment-table th td:nth-child(6) {
  width: 10%;
}
.shipment-table tr td:nth-child(7),
.shipment-table th td:nth-child(7) {
  width: 5%;
}
.shipment-table tr td:nth-child(8),
.shipment-table th td:nth-child(8) {
  width: 5%;
}
</style>


// WEBPACK FOOTER //
// src/views/ElecBoard.vue